<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 60" class="ph-flag">
    <!-- Blue -->
    <rect width="120" height="30" fill="#0038A8"/>
    <!-- Red -->
    <rect y="30" width="120" height="30" fill="#CE1126"/>
    <!-- White Triangle -->
    <polygon points="0,0 60,30 0,60" fill="#FFFFFF"/>
    <!-- Yellow Sun and Stars -->
    <g fill="#FCD116">
      <!-- Stars -->
      <!-- Star 1 (top-left) -->
      <path d="M 0,-2.2 L 0.52,-0.71 L 2.1,-0.68 L 0.84,0.27 L 1.29,1.78 L 0,0.88 L -1.29,1.78 L -0.84,0.27 L -2.1,-0.68 L -0.52,-0.71 Z" transform="translate(10, 11) rotate(18)"/>
      <!-- Star 2 (bottom-left) -->
      <path d="M 0,-2.2 L 0.52,-0.71 L 2.1,-0.68 L 0.84,0.27 L 1.29,1.78 L 0,0.88 L -1.29,1.78 L -0.84,0.27 L -2.1,-0.68 L -0.52,-0.71 Z" transform="translate(10, 49) rotate(-18)"/>
      <!-- Star 3 (right corner) -->
      <path d="M 0,-2.2 L 0.52,-0.71 L 2.1,-0.68 L 0.84,0.27 L 1.29,1.78 L 0,0.88 L -1.29,1.78 L -0.84,0.27 L -2.1,-0.68 L -0.52,-0.71 Z" transform="translate(48, 30) rotate(90)"/>
      
      <!-- Sun Center -->
      <circle cx="22" cy="30" r="5.5"/>
      <!-- Rays of the sun -->
      <!-- Vertical and Horizontal -->
      <polygon points="22,15 20.8,23.5 23.2,23.5"/>
      <polygon points="22,45 20.8,36.5 23.2,36.5"/>
      <polygon points="7,30 15.5,28.8 15.5,31.2"/>
      <polygon points="37,30 28.5,28.8 28.5,31.2"/>
      <!-- Diagonals -->
      <polygon points="32.61,40.61 25.75,35.45 27.45,33.75"/>
      <polygon points="32.61,19.39 27.45,26.25 25.75,24.55"/>
      <polygon points="11.39,19.39 18.25,24.55 16.55,26.25"/>
      <polygon points="11.39,40.61 16.55,33.75 18.25,35.45"/>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'FlagPhilippines'
}
</script>

<style scoped>
.ph-flag {
  display: inline-block;
  vertical-align: middle;
  border-radius: 2px;
  overflow: hidden;
  box-shadow: 0 1px 2px rgba(0,0,0,0.2);
  width: 100%;
  height: 100%;
}
</style>
